/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListTaskTemplatesRequest} from '@cash-web/protos/squareup/stafftasks/endpoints/list-task-templates.pb'
import {ListTaskTemplatesResponse} from '@cash-web/protos/squareup/stafftasks/endpoints/list-task-templates.pb'


export const listTaskTemplates = (request: ListTaskTemplatesRequest, options?: CashRequestOptions) => post<ListTaskTemplatesRequest, ListTaskTemplatesResponse>("/proxy/services/squareup.stafftasks.service.StaffTasksService/ListTaskTemplates", request, {...options, rejectOnError: true })